import React from "react";

const Policy = ({ title, sections, testId }) => (
  <div className="container-pad mx-auto max-w-[900px] py-16 md:py-24" data-testid={testId}>
    <span className="label-eyebrow">Legal</span>
    <h1 className="mt-3 text-4xl sm:text-5xl font-display font-medium tracking-tighter text-[#121C17]">{title}</h1>
    <p className="mt-4 text-sm text-[#5C6661]">Last updated: February 1, 2026</p>

    <div className="mt-10 space-y-8">
      {sections.map((s, i) => (
        <section key={i}>
          <h2 className="text-xl font-display font-medium text-[#121C17]">{s.h}</h2>
          <p className="mt-3 text-[#5C6661] leading-relaxed">{s.p}</p>
        </section>
      ))}
    </div>
  </div>
);

export const Privacy = () => (
  <Policy
    testId="privacy-page"
    title="Privacy Policy"
    sections={[
      { h: "Information we collect", p: "We collect the personal information you submit through our forms (name, contact, address) along with documents you upload (PAN, Aadhaar, etc.) strictly for the purpose of providing the requested compliance service." },
      { h: "How we use it", p: "Your information is used to deliver the service, communicate updates, generate invoices and fulfil legal obligations under Indian tax law." },
      { h: "Document storage", p: "All uploaded files are stored on encrypted object storage with restricted access. Only the qualified professional handling your file can access it." },
      { h: "Third parties", p: "We do not sell or rent your data. We share information only with statutory authorities (e.g. GSTN, MCA, IT Department) as required to complete your service." },
      { h: "Your rights", p: "You can request data deletion at any time by emailing privacy@finsahayak.com. Some records must be retained for 7 years under Indian tax law." },
    ]}
  />
);

export const Terms = () => (
  <Policy
    testId="terms-page"
    title="Terms & Conditions"
    sections={[
      { h: "Acceptance of terms", p: "By using FinSahayak you agree to these terms. If you don't agree, please don't use the service." },
      { h: "Service description", p: "FinSahayak is an aggregator that connects you with qualified Chartered Accountants, Company Secretaries and lawyers for compliance services." },
      { h: "Payment", p: "Service fees are charged upfront. Government fees, where applicable, are billed at actuals and communicated before collection." },
      { h: "Customer responsibility", p: "You are responsible for the accuracy of the information and documents you provide. False or incomplete information may delay or void the service." },
      { h: "Limitation of liability", p: "Our liability is limited to the service fee paid. We are not liable for indirect or consequential damages." },
      { h: "Jurisdiction", p: "These terms are governed by Indian law. Disputes are subject to the exclusive jurisdiction of the courts of Bengaluru." },
    ]}
  />
);

export const Refund = () => (
  <Policy
    testId="refund-page"
    title="Refund Policy"
    sections={[
      { h: "Refund within 24 hours", p: "If we haven't started work on your service yet, you can request a 100% refund within 24 hours of payment. Refunds are credited within 5–7 business days to the original payment method." },
      { h: "Partial refunds", p: "If work has begun but the service is incomplete, we will compute a pro-rata refund based on stages completed and refund the balance." },
      { h: "Non-refundable", p: "Government fees paid on your behalf to statutory authorities (e.g. GST registration fee, stamp duty) are non-refundable once submitted." },
      { h: "How to request", p: "Email refunds@finsahayak.com with your reference number. We'll respond within 1 business day." },
    ]}
  />
);
